<template>
  <div :class="$style.sliderContainer">
    <input
      type="range"
      :class="$style.slider"
      :min="min"
      :max="max"
      :value="modelValue"
      @input="handleInput"
    />
    <span v-if="showValue" :class="$style.value">{{ displayValue }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  modelValue: number;
  min: number;
  max: number;
  showValue?: boolean;
  valueFormatter?: (value: number) => string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: number): void;
}>();

const displayValue = computed(() => {
  if (props.valueFormatter) {
    return props.valueFormatter(props.modelValue);
  }
  return props.modelValue.toString();
});

function handleInput(event: Event) {
  const target = event.target as HTMLInputElement;
  const value = parseInt(target.value);
  emit("update:modelValue", value);
}
</script>

<style module>
.sliderContainer {
  display: flex;
  align-items: center;
  gap: 12px;
}

.slider {
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.2);
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.slider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.value {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  min-width: 60px;
  width: 60px;
  text-align: right;
  font-family: monospace;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  /* Touch-friendly slider on mobile */
  .slider::-webkit-slider-thumb {
    width: 24px;
    height: 24px;
  }

  .slider::-moz-range-thumb {
    width: 24px;
    height: 24px;
  }
}
</style>
